export const FETCH_MASTER_DDLS = "FETCH_MASTER_DDLS";
export const EMPLOYEES_DDLS = "EMPLOYEES_DDL";
export const FETCH_REQUEST_STATUS = "FETCH_REQUEST_STATUS";
export const FETCH_DEPARTMENT_DDL = "FETCH_DEPARTMENT_DDL";
export const FETCH_MASTER_ASSET_DDL = "FETCH_MASTER_ASSET_DDL";
export const FETCH_PAYROLL_COLUMN_LIST = "FETCH_PAYROLL_COLUMN_LIST";
export const FETCH_EMPLOYEE_DEPENDENT = "FETCH_EMPLOYEE_DEPENDENT";
export const FETCH_PROPERTY_TYPES = "FETCH_PROPERTY_TYPES";
export const FETCH_UNIT_TYPES = "FETCH_UNIT_TYPES";
export const FETCH_PROPERTIES_DDL = "FETCH_PROPERTIES_DDL";
export const FETCH_MASTER_BANK_DDL = "FETCH_MASTER_BANK_DDL";
export const FETCH_PAYMENT_TYPES = "FETCH_PAYMENT_TYPES";
export const FETCH_COUNTRIES = "FETCH_COUNTRIES";
export const FETCH_EMIRATES = "FETCH_EMIRATES";
export const FETCH_PROJECTS = "FETCH_PROJECTS";
